// eslint-disable-next-line import/prefer-default-export
export const checkMaxDecimalPlaces = (value: number | undefined, maxPlaces: number): boolean => {
  if (typeof value !== 'number') return false;
  if (!value) return true;
  const base = value * 10 ** maxPlaces;
  return Math.abs(Math.round(base) - base) < 1e-10;
};
